import React, { useState } from "react";

import Container from "./Container";

import { LogLinesVariables } from "./Container/types/LogLines";

type Props = {
  hideIfEmpty?: boolean;
  focusLineHandler?: (line: number | null) => void;
  onReady?: () => void;
} & LogLinesVariables;

const LogLines: React.FunctionComponent<Props> = ({
  focusLineHandler,
  ...rest
}) => {
  const [localFocusedLine, setLocalFocusedLine] = useState(undefined);

  const handleLineFocus = (occurredAt: number | null) => {
    if (focusLineHandler) {
      focusLineHandler(occurredAt);
    } else {
      setLocalFocusedLine(occurredAt);
    }
  };

  return (
    <Container
      {...rest}
      focusedOccurredAt={localFocusedLine}
      focusLineHandler={handleLineFocus}
    />
  );
};

export default LogLines;
